import { createMemoryHistory, createRouter } from "vue-router";

import { useAlertStore } from "./stores/alert.store";
import { useAuthStore } from "./stores/auth.store";
import { useBettorStore } from "./stores/bettor.store";
const progress = {
  func: [
    { call: "color", modifier: "temp", argument: "#ffb000" },
    { call: "fail", modifier: "temp", argument: "#6e0000" },
    { call: "location", modifier: "temp", argument: "top" },
    {
      call: "transition",
      modifier: "temp",
      argument: { speed: "1.5s", opacity: "0.6s", termination: 400 },
    },
  ],
};
const routes = [
  {
    path: "/",
    alias: "/checkAggregate",
    name: "checkAggregate",
    component: () => import("./pages/CheckBetsAggregateRecords"),
    meta: {
      layout: "AppLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/home/:date_requested",
    alias: "/home",
    name: "home",
    component: () => import("./pages/CheckBetor"),
    meta: {
      layout: "AppLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/Login"),
    meta: {
      layout: "DefaultLayout",
      requiresAuth: false,
    },
    // redirect: "/home",
  },
  {
    path: "/verify2fa",
    name: "verify2fa",
    layout: null,
    component: () => import("./pages/Verify2FA"),
    meta: {
      layout: "DefaultLayout",
    },
  },
  {
    path: "/setting",
    name: "setting",
    layout: null,
    component: () => import("./pages/Settings/ListPage"),
    meta: {
      layout: "AppLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/activity/:uuid",
    name: "activityDetail",
    props: true,
    component: () => import("./pages/CheckBetorDetail"),
    meta: {
      layout: "AppLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/activity",
    name: "activity",
    props: true,
    component: () => import("./pages/Activity/ProActivity"),
    meta: {
      layout: "AppLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/activity/proBetInc/:id",
    component: () => import("./pages/Activity/ProBetInc"),
    name: "proBetInc",
    props: true,
    meta: {
      layout: "AppLayout",
      requiresAuth: true,
    },
  },
  {
    path: '/full-match-list',
    name: 'FullMatchList',
    component: () => import('./pages/FullMatchList'),
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createMemoryHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  to.meta.progress = progress;
  const alertStore = useAlertStore();
  const bettorStore = useBettorStore();
  alertStore.clear();
  const store = useAuthStore();
  // Verify the activation key
  store.verifyActivationKey({ license_key: "" });
  // Set default tab and reset specific object if not navigating to 'proBetInc' or 'activity'
  if (to.name !== 'proBetInc' && to.name !== 'activityDetail' && to.name !== 'activity' && to.name !== 'home') {
    bettorStore.resetSpecificObject();
    localStorage.setItem('activeTab', 'potInc');
  }
  if (to.name !== 'proBetInc' && to.name !== 'activityDetail' && to.name !== 'checkAggregate' && to.name !== 'home') {
    bettorStore.resetTimeZoneAndCheckHistory();
  }

  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // This route requires auth, check if logged in
    // If not, redirect to login page
    if (!store.user) {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    next(); // Does not require auth, make sure to always call next()
  }
});


export default router;
